module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "1F641.c7d9ee53.svg";